import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import Icon, { IconSize } from '@helsenorge/designsystem-react/components/Icon';
import Toolbox from '@helsenorge/designsystem-react/components/Icons/Toolbox';
import Title from '@helsenorge/designsystem-react/components/Title';
import { Tool } from './Tool';
import { ToolList } from './ToolList';
import { getNextTitleLevel, useToolData } from './utils';
import styles from './styles.module.scss';
const ToolBlock = ({ toolIdList, title, titleHtmlMarkup, backgroundColor, ...rest }) => {
    const toolData = useToolData(toolIdList);
    if (!toolData || toolData.length === 0) {
        return null;
    }
    const isSingle = toolData.length === 1;
    const toolTitleHtmlMarkup = getNextTitleLevel(titleHtmlMarkup);
    const blockClasses = classNames(styles.toolblock, backgroundColor === 'blueberry' && styles[`toolblock--blueberry`], backgroundColor === 'cherry' && styles[`toolblock--cherry`], backgroundColor === 'neutral' && styles[`toolblock--neutral`], isSingle && styles[`toolblock--single`]);
    const renderTools = () => {
        if (isSingle) {
            return _jsx(Tool, { tool: toolData[0], toolTitleHtmlMarkup: toolTitleHtmlMarkup, ...rest, single: true });
        }
        return _jsx(ToolList, { tools: toolData, color: backgroundColor, toolTitleHtmlMarkup: toolTitleHtmlMarkup, ...rest });
    };
    return (_jsxs("div", { className: blockClasses, children: [_jsxs("div", { className: styles.toolblock__header, children: [_jsx(Icon, { svgIcon: Toolbox, size: IconSize.Medium }), _jsx(Title, { appearance: "title2", htmlMarkup: titleHtmlMarkup, children: title })] }), renderTools()] }));
};
export default ToolBlock;
